import { api } from './axios'

export const notificationsAPI = {
  // Get user notifications (customer only)
  getNotifications: async (params) => {
    const response = await api.get('/customer/notifications', { params })
    return response.data
  },

  // Mark notification as read (customer only)
  markAsRead: async (notificationId) => {
    const response = await api.patch(`/customer/notifications/${notificationId}/read`)
    return response.data
  },

  // Mark all as read (customer only)
  markAllAsRead: async () => {
    const response = await api.patch('/customer/notifications/read-all')
    return response.data
  },


  createShippingNotification: async ({ orderNumber, state, stateText }) => {
    const response = await api.post('/customer/notifications/shipping-update', {
      orderNumber,
      flashState: state,
      stateText,
    })
    return response.data
  },

  // Delete notification (customer only)
  deleteNotification: async (notificationId) => {
    const response = await api.delete(`/customer/notifications/${notificationId}`)
    return response.data
  },

  // Get unread count (customer only)
  getUnreadCount: async () => {
    const response = await api.get('/customer/notifications/unread-count')
    return response.data
  },

  // Subscribe to push notifications (customer only)
  subscribePush: async (subscription) => {
    const response = await api.post('/customer/notifications/subscribe', subscription)
    return response.data
  },

  // Unsubscribe from push notifications (customer only)
  unsubscribePush: async () => {
    const response = await api.post('/customer/notifications/unsubscribe')
    return response.data
  }
}